// C:/Users/remyc/OneDrive/Desktop/Projets/lab/Web/sprint_manager/frontend/src/components/GlobalCurrentDayLine.js
import React from 'react';

const GlobalCurrentDayLine = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return null;
  const today = new Date();
  const startTime = startDate.getTime();
  const endTime = endDate.getTime();

  if (Number.isNaN(startTime) || Number.isNaN(endTime) || today < startDate || today > endDate) {
    return null;
  }

  const totalDays = Math.max(1, Math.ceil((endTime - startTime) / (1000 * 60 * 60 * 24)));
  const daysPassed = Math.max(0, Math.ceil((today.getTime() - startTime) / (1000 * 60 * 60 * 24)));
  const position = (daysPassed / totalDays) * 100;
  const formattedLabel = today.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
  });

  return (
    <div
      className="absolute inset-y-0 w-0.5 bg-rose-500 z-10"
      style={{
        left: `${position}%`,
        pointerEvents: 'none',
      }}
    >
      <div className="absolute -top-4 -translate-x-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-semibold text-rose-600 shadow">
        Aujourd'hui · {formattedLabel}
      </div>
      <span className="absolute -bottom-1 -translate-x-1/2 rounded-full bg-rose-500 p-1 shadow" />
    </div>
  );
};

export default GlobalCurrentDayLine;
